export const p2pPlayerSettingsServiceTypes = {
    service: Symbol('P2PPlayerSettingsService'),
} as const;
